import { createFileRoute } from "@tanstack/react-router";
import type { SearchSchemaInput } from "@tanstack/react-router";
import { PAGE_KEYS, type PageKey } from "@/components/admin/_adminPages";
import { AdminPendingScreen, AdminErrorScreen } from "@/components/admin/AdminRouteFallbacks";

export const Route = createFileRoute("/_authenticated/admin/")({
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => {
    const raw = typeof search.page === "string" ? search.page : undefined;
    const unknownRaw = typeof search.unknown === "string" ? search.unknown : undefined;
    const valid = raw && PAGE_KEYS.has(raw as PageKey) ? (raw as PageKey) : "dashboard";
    const unknown = unknownRaw ?? (raw && !PAGE_KEYS.has(raw as PageKey) ? raw : undefined);
    const ticketRaw = typeof search.ticket === "string" ? search.ticket : undefined;
    const ticket = ticketRaw && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(ticketRaw)
      ? ticketRaw
      : undefined;
    return { page: valid, unknown, ticket };
  },
  pendingComponent: AdminPendingScreen,
  errorComponent: AdminErrorScreen,
  pendingMs: 0,
});
